import { render, staticRenderFns } from "./CallStats.vue?vue&type=template&id=dca03ee6&scoped=true&"
import script from "./CallStats.vue?vue&type=script&lang=js&"
export * from "./CallStats.vue?vue&type=script&lang=js&"
import style0 from "./CallStats.vue?vue&type=style&index=0&id=dca03ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca03ee6",
  null
  
)

export default component.exports